
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic06 as ObiLogic06Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-06.js';
 
 
 

 
 export const ObiLogic06 = createComponent({
   react: React,
   tagName: 'obi-logic-06',
   elementClass: ObiLogic06Element,
   events: {
     
   }
  });
 
 